import React from "react";
import Popup from "reactjs-popup";
import { lrMasterApiConfig } from "../config/apiConfig.js";
import {
  groupInfo,
  dataObject,
  validate,
  popupInfo,
} from "../config/lrMasterForm.js";
import FormColumn from "./FormColumn.js";
import { Prompt } from "react-router-dom";
import "./Form.css";
import "./ChallanForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm.js";
import "./popup.css";
import Autosuggest from "react-autosuggest";
import { SERVER_URL } from "../config/config.js";

const LrMasterForm = ({ sessionObject }) => {
  let variablesFromSession = {
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
  };

  const myForm = useForm(
    "LrMaster",
    validate,
    { ...dataObject, ...variablesFromSession },
    lrMasterApiConfig,
  );

  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    return null;
  };

  const checkDisabledCondition = (fieldInfo) => {
    return "";
  };

  const checkVisibilityCondition = (fieldInfo) => {
    return true;
  };

  React.useEffect(() => {
    console.log(myForm.pageState);
  });

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  return (
    <div className="challan-form-container">
      <Popup
        open={myForm.pageMode === "submitted" || myForm.pageMode === "error"}
        modal
        contentStyle={contentStyle}
        closeOnDocumentClick={false}
      >
        {(close) => (
          <div className="pop-up-container">
            <div className="pop-up-header">
              {myForm.pageMode === "submitted" ? (
                <div>{popupInfo.success_header}</div>
              ) : (
                <div>{popupInfo.error_header}</div>
              )}

              <div>
                <a className="pop-up-close btn" onClick={close}>
                  &times;
                </a>
              </div>
            </div>

            {myForm.pageMode === "submitted" ? (
              <div className="pop-up-content">
                {popupInfo.success_title}
                <br />
                <div className="pop-up-fields">
                  <div className="pop-up-field">
                    <div className="pop-up-field-label">
                      {popupInfo.field_label_success}
                    </div>
                    <div className="pop-up-field-value">
                      {myForm.pageState[popupInfo.field_name_success]}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="pop-up-content">
                {popupInfo.error_title}
                <br />
                <div className="pop-up-fields">
                  <div className="pop-up-field">
                    <div className="pop-up-field-label">
                      {popupInfo.field_label_error}
                    </div>
                    <div className="pop-up-field-value">
                      {myForm.popupError}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="pop-up-actions">
              <button
                className="pop-up-button"
                onClick={() => {
                  if (myForm.pageMode === "submitted") {
                    myForm.setPageState({
                      ...dataObject,
                      ...variablesFromSession,
                    });

                    myForm.setPageMode("write");
                    window.location.reload();
                    close();
                  } else {
                    if (myForm.previousPageMode !== "") {
                      myForm.setPageMode(myForm.previousPageMode);
                      myForm.setPreviousPageMode("");
                    } else {
                      myForm.setPageMode("write");
                    }

                    close();
                  }
                }}
              >
                Okay
              </button>
            </div>
          </div>
        )}
      </Popup>

      <div className="form-header">LR Master</div>
      <div onSubmit={myForm.handleSubmit} className="form" noValidate>
        <div className="form-title"></div>
        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>
        </div>
        <div className="form-footer">
          <button
            onClick={myForm.handleSubmit}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          {/* <div className="status">{myForm.renderSubmitApiResponseStatus()}</div> */}
        </div>
      </div>
    </div>
  );
};

export default LrMasterForm;
